import { Button } from '@zillow/constellation';
import { TourAvailabilityCalendarFooterContainer } from './StyledComponents';
import { TourWizardSteps } from '../../../../constants/TourCalendar';

type TourAvailabilityCalendarFooterProps = {
  isNextDisabled: boolean;
  onClickBack: () => void;
  onClickNext: () => void;
  step: TourWizardSteps;
  hasEnabledTouring: boolean;
};

const TourAvailabilityCalendarFooter = ({
  isNextDisabled,
  onClickBack,
  onClickNext,
  step,
  hasEnabledTouring,
}: TourAvailabilityCalendarFooterProps) => {
  const isCalendarStep = step === TourWizardSteps.CALENDAR;
  const hasBackButton = (isCalendarStep || step === TourWizardSteps.TIME_ZONE) && !hasEnabledTouring;

  return (
    <TourAvailabilityCalendarFooterContainer
      display="flex"
      justifyContent={hasBackButton ? 'space-between' : 'flex-end'}
      marginX={{ default: 0, lg: 'xl' }}
      marginY={{ default: 0, lg: 'xs' }}
      gap="md"
    >
      {hasBackButton && (
        <Button
          fluid={{ default: true, lg: false }}
          buttonType="secondary"
          onClick={onClickBack}
          data-testid="TourCalendarFooter-BackBtn"
        >
          Back
        </Button>
      )}
      <Button
        fluid={{ default: true, lg: false }}
        buttonType="primary"
        disabled={isNextDisabled}
        onClick={onClickNext}
        data-testid="TourCalendarFooter-NextBtn"
      >
        {isCalendarStep ? 'Close' : 'Next'}
      </Button>
    </TourAvailabilityCalendarFooterContainer>
  );
};

export default TourAvailabilityCalendarFooter;
